import { pick, pipe, reduce, values } from 'ramda';
import { PERIOD_CODES } from './constants';

export const parseDate = d => d ? new Date(`${d.replace(' ', 'T')}Z`) : null;

export const parseAllLimits = limits => limits
    .map(limit => ({
        ...limit,
        startDate: parseDate(limit.startDate),
        endDate: parseDate(limit.endDate),
        resetDate: parseDate(limit.resetDate),
        periodStartDate: parseDate(limit.periodStartDate),
        timePeriod: limit.timePeriod.toLowerCase()
    }))
    .reduce((acc, limit) => {
        const { timePeriod, pending = false } = limit;
        const key = pending ? 'pendingLimits' : 'actualLimits';

        acc[key] = {
            ...acc[key],
            [timePeriod]: limit
        };

        return acc;
    }, { actualLimits: {}, pendingLimits: {} });

export const parseConfig = (props) => {
    const { availablePeriods: rawAvailablePeriods } = props;

    const availablePeriods = pipe(
        pick(rawAvailablePeriods),
        values
    )(PERIOD_CODES);

    const defaultFieldValues = reduce(
        (res, field) => ({ ...res, [field]: '' }),
        {}
    )(availablePeriods);

    return {
        ...props,
        availablePeriods,
        defaultFieldValues
    };
};

export default ({ data: { limits } }) => parseAllLimits(limits);
